import api from "./api.js";
export default {
    name: "App",
    data: () => ({
        valid: false,
        snackbar: false,
        buttonloading: false,
        text: "",
        timeout: 2000,

        normalRules: [
            (v) => !!v || "Field is required",
        ],
        login_email: null,
        login_password: null,
    }),
    mounted() {
        if (this.$store.state.admin != null) {
            this.$router.replace("/admin/dashboard");
        }
    },
    methods: {
        login() {
            this.loading = true;
            if (this.$refs.loginform.validate()) {
                api
                    .login({
                        email: (this.login_email.trim()).toLowerCase(), password: this.login_password
                    })
                    .then((res) => {
                        this.loading = false;
                        if (res.data.responseCode === 1) {
                            this.$store.commit("login", res.data.data);
                            this.$router.push("/admin/dashboard");
                            this.loading = false;
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        this.text = error;
                        this.snackbar = true;
                    });
            }
            return;


        },
    }
};
